import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* align-items: ; */
  align-content: start;
  gap: 10px;
  padding: 10px;
  overflow: auto;
  /* height: 100%; */
`;
